import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import SplashScreen from '../../features/auth/components/SplashScreen/SplashScreen';
import useIsMobileView from '../../hooks/useIsMobileView';
import LinkWithText from './components/LinkWithText';
import { twMerge } from 'tailwind-merge';
import ROUTES from '../../routers/Routes';

const WelcomeView = () => {
  const navigate = useNavigate();
  const isMobileView = useIsMobileView();

  const handleGoToLobby = () => {
    navigate(ROUTES.LOBBY);
  };
  return (
    <div
      className={twMerge(
        !isMobileView && 'max-w-[300px]',
        'scrollbar-phenom mb-20 flex h-full w-auto min-w-96 flex-col gap-5 overflow-auto bg-ph-gray-cod px-11 py-20',
      )}
    >
      <h1 className="font-obvia text-2xl font-black uppercase text-ph-gray-white">WELCOME!</h1>

      <p className="leading-tight text-ph-primary-violet">
        Welcome to an innovative community at the forefront of the revolution in online gaming.
      </p>

      <p className="text-sm text-ph-gray-white">
        Connect with fellow poker enthusiasts, share strategies, and stay updated with all the latest news.
      </p>

      <LinkWithText
        url="#"
        title="Join Our Discord"
        text="This is where our heart beats. Live chats, exclusive events, and a
            chance to mingle with the pros."
      />

      <LinkWithText
        url="#"
        title="Follow Us on X"
        text="For real-time updates. It’s your gateway to a community that never
            sleeps."
      />

      <LinkWithText
        url="#"
        title="Check Our Blog"
        text="Insightful articles, player spotlights, and the latest news in the
            world of online poker. Updated regularly to keep you in the loop."
      />

      <Button onClick={handleGoToLobby} fullWidth type="button" className="mt-5">
        Continue to Lobby
      </Button>
    </div>
  );
};

const Welcome = () => {
  const isMobileView = useIsMobileView();

  if (isMobileView) {
    return <WelcomeView />;
  }

  return (
    <SplashScreen>
      <WelcomeView />
    </SplashScreen>
  );
};

export default Welcome;
